<header class="header-top" header-theme="light" style="font-weight: 500">
  <div class="container-fluid">
    <div class="d-flex justify-content-between">
      <div class="top-menu d-flex align-items-center">
        <button type="button" class="btn-icon mobile-nav-toggle d-lg-none">
          <span></span>
        </button>

        <!--  <div class="dropdown">
                <a class="dropdown-toggle" href="#" id="userRolesDropdown" role="button" data-toggle="dropdown">
                    <i class="ik ik-chevron-down"></i> <span style="font-size: 14px">{{selectedRole}}</span>  </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userRolesDropdown">
                    <ng-container *ngFor="let role of roles" >
                            <a class="dropdown-item" href="#" (click)="ChosseRole(role)"> {{role}}</a>
                    </ng-container>
                   
                  </div>
            </div> -->

        <!--   <div class="dropdown">
                  <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                      <i class="ik ik-chevron-down"></i>
                    <img class="avatar" src="assets/images/avatar.png" alt=""> <span style="font-size: 14px">  {{global.FirstName }} {{global.LastName}}     </span>  </a>
                  <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown"> -->
        <!-- <a class="dropdown-item" href="profile.html"><i class="ik ik-user dropdown-icon"></i> Profile</a>
                      <a class="dropdown-item" href="#"><i class="ik ik-settings dropdown-icon"></i> Settings</a>
                      <a class="dropdown-item" href="#"><span class="float-right"><span class="badge badge-primary">6</span></span><i class="ik ik-mail dropdown-icon"></i> Inbox</a>
                      <a class="dropdown-item" href="#"><i class="ik ik-navigation dropdown-icon"></i> Message</a> -->
        <!--     <a class="dropdown-item" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon"></i>{{'ToolBar.Logout'|translate}}</a>
                    </div>
              </div> -->

        <!-- <a class="header-brand" [routerLink]="['/']">
                <div class="logo-img">
                   <img src="assets/images/logoex5.png" class="header-brand-img" alt="SEU"> 
                </div>
          
            </a> -->
      </div>

      <div class="top-menu d-flex align-items-center">
        <!--  <div class="d-none d-sm-block">
            <div class="input-group">
             

              <div class="dropdown search">
                <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                  <span style="font-size: 14px">  Choose Clinic    </span> 
                  <i class="ik ik-chevron-down"></i> </a>
                <div class="dropdown-menu dropdown-menu-right se" aria-labelledby="userDropdown">
                    <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Dentist</a> 
                    <a class="dropdown-item" href=""><i class="ik ik-heart dropdown-icon"></i> Pediatrics</a>
                     
                  </div>
            </div>

              <input type="text" class="form-control" placeholder="Search By Doctor Name">

              <div class="input-group-append">
                <button class="btn btn-search" type="button"><i class="ik ik-search"></i></button>
              </div>

            </div>
          </div> -->
      </div>

      <div class="top-menu d-flex align-items-center">
        <!-- <button type="button" class="btn-icon mobile-nav-toggle d-lg-none"><span></span></button> -->
        <!--   <div class="header-search">
                <div class="input-group">
                    <span class="input-group-addon search-close"><i class="ik ik-x"></i></span>
                    <input type="text" class="form-control">
                    <span class="input-group-addon search-btn"><i class="ik ik-search"></i></span>
                </div>
            </div> -->

        <!-- Dependatnt Or Dependent List-->

        <!--  <div class="dropdown" *ngIf="isEmpolyee">-->
        <!--  <div class="dropdown" *ngIf="this.global.Role == 'EmployeePatient'">
              
                <a class="dropdown-toggle" href="javascript:void(0);" id="employeeDependants" role="button" data-toggle="dropdown">
                    <i class="ik ik-chevron-down"></i> <span style="font-size: 14px">{{selectedDependant}}</span>  </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userRolesDropdown">
                    <a class="dropdown-item" href="javascript:void(0);"  (click)="ChooseDependant(loginUserId,loginUserName,loginPatientId)"> {{loginUserName}}</a>                 
                    <ng-container *ngFor="let dep of empDependants" >
                            <a class="dropdown-item" href="javascript:void(0);"  (click)="ChooseDependant(dep.dependentUserId,dep.userName,dep.patientId)"> {{dep.userName}}</a>
                    </ng-container>
                   
                  </div>
            </div> -->

        <!-- User Role List-->
        <!-- <div class="dropdown">
              <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                <i class="ik ik-chevron-down"></i> -->
        <!-- <img class="avatar" src="assets/images/avatar.png" alt="">  -->
        <!--                 <span style="font-size: 14px"> {{global.CurrentLang == 'AR' ? selectedRoleDetails.arRoleName : selectedRoleDetails.enRoleName}} </span>
 -->
        <!-- <span style="font-size: 14px">  {{selectedRole}}     </span> -->
        <!--   </a>
              <div class="dropdown-menu  user-drop" aria-labelledby="userDropdown">
                <a class="dropdown-item" href="javascript:void(0);" *ngFor="let role of userRolesDetails ;let i=index;"
                  (click)="ChangeUserRole(role)"><i class="ik ik-user dropdown-icon"></i>
                  {{global.CurrentLang == 'AR' ? role.arRoleName : role.enRoleName}}</a>
              </div>
              
            </div> -->

        <!--  <div class="dropdown">
              <a class="dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown">
                  <i class="ik ik-chevron-down"></i>
            
                <span style="font-size: 14px">  {{global.FirstName }} {{global.LastName}}     </span>  </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                  <a class="dropdown-item" href="#"><i class="ik ik-user dropdown-icon"></i> de user</a> 
                  <a class="dropdown-item" href="#"><i class="ik ik-user dropdown-icon"></i> de user</a>
                
                  <a class="dropdown-item" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon"></i>{{'ToolBar.Logout'|translate}}</a>
                </div>
          </div>
        -->
        <div class="header-date d-none d-lg-block" style="direction: rtl">
          <!-- <span class="media" style="font-size: 14px;">
             
                  <span>
                    <span *ngIf="translate.currentLang == 'en'" style="color: #fff;">m</span>
                   
      
                     {{ getDate()  }}
      
                  </span>
      
                  
      
                  &nbsp; &nbsp;  - &nbsp; &nbsp;
                  <span class="" id="date">
                  </span>
                </span> -->
        </div>

        <!-- 
            <div class="dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="notiDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="UpdateNotificationsToReaded()"><i class="ik ik-bell"></i><span class="badge bg-danger">{{ getNotReadCount() }}</span></a>
                <div class="dropdown-menu dropdown-menu-right notification-dropdown" aria-labelledby="notiDropdown" >
                    <h4 class="header">{{'ToolBar.Notifications'|translate}}</h4>
                        
                          
                      <span *ngFor="let item of global.Notifications">
                    <div class="notifications-wrap"  > 
                        
                        <span class="media">
                            <span class="d-flex">
                                <i class="ik ik-check"></i> 
                            </span>
                            <span class="media-body" >
                                <a href='{{item.action}}' class="heading-font-family media-heading">{{item.message}}</a> 
                                
                            </span>
                        </span>
                     
                    </div>
                  </span>
                    <div class="footer"><a  [routerLink]="['/notification/']" >{{'ToolBar.SeeAll'|translate}} </a></div>
                </div>
            </div> -->

        <div id="drop2" class="dropdown">
          <a
            class="dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            style="line-height: 1.9"
          >
            <!-- <i class="ik ik-chevron-down" style="color:#000"></i> -->
            <img
              src="assets/images/icons/header-arrow-down.svg"
              alt="arrow down icon"
            />
            <!-- <img class="avatar" src="assets/images/saudi-avatar.jpg" alt="" /> -->
            <img
              src="assets/images/icons/avatar.svg"
              class="avatar"
              alt="avatar"
            />
            <span style="font-size: 14px"> </span>
            <span style="font-size: 14px; color: #000"
              >{{ LoginFullName }}
            </span>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right"
            aria-labelledby="userDropdown"
          >
            <!-- <a class="dropdown-item" href="profile.html"><i class="ik ik-user dropdown-icon"></i> Profile</a>
                  <a class="dropdown-item" href="#"><i class="ik ik-settings dropdown-icon"></i> Settings</a>
                  <a class="dropdown-item" href="#"><span class="float-right"><span class="badge badge-primary">6</span></span><i class="ik ik-mail dropdown-icon"></i> Inbox</a>
                  <a class="dropdown-item" href="#"><i class="ik ik-navigation dropdown-icon"></i> Message</a> -->
            <a
              class="dropdown-item"
              routerLink=""
              (click)="logOut()"
              style="color: #000"
            >
              <!-- <i class="ik ik-power dropdown-icon"></i> -->
              <img
                src="assets/images/icons/log-out-icon.svg"
                alt="log out icon"
              />
              تسجيل خروج</a
            >
          </div>
        </div>
        <!-- <div class="lang" >   
              <a class="" routerLink="" (click)="logOut()"><i class="ik ik-power dropdown-icon" style="font-size: 20px; font-weight: 400"></i></a>
            </div>  -->
        <!-- <button type="button" id="navbar-fullscreen" class="nav-link"><i class="ik ik-maximize"></i></button> -->
        <div class="lang">
          <a
            href="javascript:void(0)"
            *ngIf="global.CurrentLang == 'en'"
            class="social"
            style="margin: 0 10px"
            (click)="langAR('AR')"
          >
            <!-- <img src="assets/images/ar.png" width="25px" /> -->
            <img src="assets/images/icons/lang.svg" width="25px" />
            عربي
          </a>
          <a
            href="javascript:void(0)"
            *ngIf="global.CurrentLang == 'AR'"
            class="social"
            style="margin: 0 10px"
            (click)="langEn('en')"
          >
            <!-- <img src="assets/images/en.png" width="25px" /> -->
            <img src="assets/images/icons/lang.svg" width="25px" />
            English
          </a>
        </div>
      </div>
    </div>
  </div>
</header>
